
import React, { useState } from 'react'
import { Col, Form, Row } from 'react-bootstrap'
import moment from 'moment'
import { useDispatch } from 'react-redux'

import useTranslation from '@/Hooks/UseTranslation'
import { useProgrammation } from '@/Hooks/UseProgrammation'
import { useProject } from '@/Hooks/UseProject'
import { useDatePicker } from '@/Hooks/UseDatePicker'

import { updateTaskAction } from '@/Redux/Actions/ProgrammationManagerActions'
import { updateTaskScheduledDates } from '@/Services/ProgrammationManagerService'

import InputText from '../../components/InputText'

const TaskScheduledDates = () => {

  const { t } = useTranslation()

  const dispatch = useDispatch()

  const { itemOpened: task, patchItemOpened, setEditingItem } = useProgrammation()
  const { project, nonWorkingDays } = useProject()

  const { showDateRangePicker } = useDatePicker()

  const [ startsAt, setStartsAt ] = useState(moment(task.startsAt).format('YYYY-MM-DD'))
  const [ endsAt, setEndsAt ] = useState(moment(task.endsAt).format('YYYY-MM-DD'))

  const saveChanges = async (startsAt: string, endsAt: string) => {
    setEditingItem(true)

    const [ error, data ] = await updateTaskScheduledDates(task._id, startsAt, endsAt)

    setEditingItem(false)

    if (error) {
      return false
    }

    patchItemOpened({
      startsAt: data.task.startsAt,
      endsAt: data.task.endsAt,
      executeDays: data.task.executeDays,
    })

    await dispatch(updateTaskAction(data.task, data.updatedTasks))
  }

  const handleChangeDates = async (dates: any) => {

    const {
      startDate,
      endDate
    } = dates

    setStartsAt(startDate)
    setEndsAt(endDate)

    await saveChanges(startDate, endDate)
  }

  const handleShowDateRangePicker = () => {

    showDateRangePicker({
      startDate: startsAt,
      endDate: endsAt,
      projectStartDate: project.startsAt,
      projectEndDate: project.endsAt,
      nonWorkingDays,
      onChangeRange: handleChangeDates
    })
  }

  return (
    <>
      <Row>
        <Col sm={4}>
          <Form.Group>
            <Form.Label>
              {t('PROGRAMMATION_MANAGER:StartsAtLabel')}
            </Form.Label>
            <InputText
              value={moment(startsAt).format('DD/MM/YYYY')}
              placeholder="dd/mm/yyyy"
              onClick={handleShowDateRangePicker}
              asButton
            />
          </Form.Group>
        </Col>
        <Col sm={4}>
          <Form.Group>
            <Form.Label>
              {t('PROGRAMMATION_MANAGER:EndsAtLabel')}
            </Form.Label>
            <InputText
              value={moment(endsAt).format('DD/MM/YYYY')}
              placeholder="dd/mm/yyyy"
              onClick={handleShowDateRangePicker}
              asButton
            />
          </Form.Group>
        </Col>
        <Col sm={4}>
          <Form.Group>
            <Form.Label>
              {t('PROGRAMMATION_MANAGER:ExecuteDaysLabel')}
            </Form.Label>
            <InputText
              value={task.executeDays}
              disabled
            />
          </Form.Group>
        </Col>
      </Row>
    </>
  )
}

export default TaskScheduledDates
